import React, { useEffect, useState } from 'react'
import {Box, Grid, GridItem,IconButton, Heading, Tab, TabList, TabPanel, TabPanels, Tabs,Flex,Text, Input, Spacer} from '@chakra-ui/react'
import NavBar from '../../../elements/NavBar'
import {useHistory} from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ActionCreators } from "../../../../redux/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CPUpcoming from './components/CPUpcoming'
import CPClossed from './components/CPMissed'
import CPPaid from './components/CPPaid'
import CustomButton from '../../../elements/customButton'
import Loader from '../../../elements/loader'

const tabNames = [
    {
        id: 1,
        name: 'Upcoming',
    },
    {
        id: 2,
        name: 'Missed',
    },
    {
        id: 3,
        name: 'Paid',
    },
]


function Collection(props) {
    const cpState = useSelector((state) => state.cpState)
    const [selectedTab, setSelectedTab] = useState(tabNames[0].name)
    const adminState = useSelector((state) => state.adminState)
    const userData = adminState?.getUserByToken?.data?.data
    const collectionData = cpState?.CPCollectionData?.data?.data

    useEffect(() => {
        props.actions.getUserByTokenAction()
    }, [])

    useEffect(() => { 
        if (selectedTab === "Upcoming") {
            props.actions.getCPCollectionAction({type: 2})
        } else if (selectedTab === "Missed"){
            props.actions.getCPCollectionAction({type: 3})
        } else if (selectedTab === "Paid"){
            props.actions.getCPCollectionAction({type: 4})
        }
    }, [selectedTab])

    const handleTabChange = (index) =>   {  
        setSelectedTab(tabNames[index].name)
    }

    const handleVerify = () => {}



  return (
    <>
        {(cpState?.CPCollectionData?.loading || adminState?.getUserByToken?.loading) && (
            <div>
                <Loader />
            </div>
        )}
        <Box className='dashboard_box bg_shadow'>
            <Grid className="main_grid_container align-items-center">
                <GridItem colSpan={8}>
                    <Heading as="h2" className='font-poppins page_heading'>Collection </Heading>
                </GridItem>
                <GridItem colSpan={4}>
                    <NavBar data={userData} isAdmin isCP />
                </GridItem>
            </Grid>
            <Flex mt={5} alignItems='end' justifyContent='end' gap={2} className='custom_select'>
            </Flex>
            <Box mt={1}>
            </Box>
            <Box mt={5}>
                <Tabs className='tabs_container' onChange={handleTabChange}>
                    <TabList className='tabs_list'>
                        {tabNames?.map((item, index) => {
                            return (
                                <Tab key={index}>{item.name}</Tab>
                            )
                        })}
                    </TabList>
                    <TabPanels>
                        {tabNames.map((item, index) => {
                            return (
                                <TabPanel key={index} className='tab_panel'>
                                    {item.name === 'Upcoming' &&
                                        <CPUpcoming
                                            collectionData={collectionData}
                                            handleVerify = {handleVerify}
                                        />
                                    }
                                    {item.name === 'Missed' &&
                                        <CPClossed
                                        collectionData={collectionData}
                                        handleVerify = {handleVerify}
                                        />
                                    }
                                    {item.name === 'Paid' &&
                                        <CPPaid
                                        collectionData={collectionData}
                                        handleVerify = {handleVerify}
                                        />
                                    }
                                </TabPanel>
                            )
                        })}
                    </TabPanels>
                </Tabs>
            </Box>

            
        </Box>
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(ActionCreators, dispatch),
  });
  
  export default connect(null, mapDispatchToProps)(Collection);
  